import React from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  value: string | Date | number | null
  options?: Intl.DateTimeFormatOptions
  variant?: 'short' | 'long'
}

const FormattedDate: React.FC<Props> = ({ value, options, variant }) => {
  const { i18n } = useTranslation()

  if (!value) return null

  const date = new Date(value)
  let opts: Intl.DateTimeFormatOptions
  switch (variant) {
    case 'long':
      opts = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', ...options }
      break
    case 'short':
    default:
      opts = { year: 'numeric', month: 'short', day: 'numeric', ...options }
      break
  }
  try {
    return (
      <span className='whitespace-nowrap'>{new Intl.DateTimeFormat(i18n.language || 'en-US', opts).format(date)}</span>
    )
  } catch (e) {
    console.error(e)
    return null
  }
}

export default FormattedDate
